import React, { useState } from "react";
import { useSelector } from "react-redux";

import LeftIconButton from "../../UI/buttonUI/LeftIconButton";
import { ListFilter } from "lucide-react";
import Modal from "../../portal/Modal";
import MobileFilterList from "./MobileFilterList";
import { modifyCategory } from "../../../functions/filter/modifyCategory";
import FilterReset from "../FilterReset";

const MobileFIlterView = ({
  categoryAndOptionList,
  selectedItems,
  setSelectedItems,
  handleFilter,
  originalData,
}) => {
  const isFiltered = useSelector((state) => state.isTableFilter.isFiltered);
  const [showFilterDialog, setShowFilterDialog] = useState(false);

  const isDesktop = window.innerWidth >= 1000;
  if (isDesktop) return null; // Do not render anything if mobile

  const openFilterDialog = () => {
    setShowFilterDialog(true);
  };
  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  return (
    <>
      <LeftIconButton
        text="Filter"
        btnStyle="text-white bg-dark-blue ml-2 mr-1 2xs:max-md:ml-0 hover:bg-[#021472e3]"
        Icon={ListFilter}
        size={15}
        onClick={openFilterDialog}
      />
      {showFilterDialog ? (
        <Modal
          onClose={closeFilterDialog}
          modalWidth="w-full rounded-t-2xl p-4"
          modalPosition="bottom-0 left-0 right-0 h-5/6 overflow-auto"
        >
          <>
            <h3 className="text-lg">FILTER</h3>
            {categoryAndOptionList.map((cate, ind) => (
              <MobileFilterList
                key={cate.name}
                name={cate.name}
                selectedItemsLen={selectedItems[modifyCategory(cate.name)]}
                optionsList={cate.optionsList}
                valueAddress={cate.valueAddress}
                setSelectedItems={setSelectedItems}
                unsort={cate.unsort}
              />
            ))}
            <LeftIconButton
              text="Filter"
              btnStyle="text-white bg-dark-blue hover:bg-[#021472e3] ml-2 mr-1 2xs:max-md:ml-0 text-white"
              Icon={ListFilter}
              size={15}
              onClick={handleFilter}
            />
            {isFiltered && (
              <FilterReset
                setSelectedItems={setSelectedItems}
                originalData={originalData}
              />
            )}
          </>
        </Modal>
      ) : (
        ""
      )}
    </>
  );
};

export default MobileFIlterView;
